/* eslint-disable */

import React from 'react';
import PropTypes from 'prop-types';

import { useField } from 'react-final-form';

import './radio-button.scss';

const RadioButton = ({ name, value, label }) => {
    const { input } = useField(name, {
        value,
        type: 'radio',
    });

    return (
        <label className="radio-button">
            <input className="radio-button__input" {...input} />
            <span className="radio-button__icon" />
            <span className="radio-button__label">{label}</span>
        </label>
    );
};

RadioButton.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
};

export { RadioButton };
